import { render, staticRenderFns } from "./FunnelAgentsPermissions.vue?vue&type=template&id=667afa36&scoped=true&"
import script from "./FunnelAgentsPermissions.vue?vue&type=script&lang=js&"
export * from "./FunnelAgentsPermissions.vue?vue&type=script&lang=js&"
import style0 from "./FunnelAgentsPermissions.vue?vue&type=style&index=0&id=667afa36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667afa36",
  null
  
)

export default component.exports